(function () {
  'use strict';
  var tvT=function(value){return window.TilvyI18n?window.TilvyI18n.t(value):value;};

  if (window.__tilvyOneClickExtrasLoaded) return;
  window.__tilvyOneClickExtrasLoaded = true;

  var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (routeRoot.slice(-1) !== '/') routeRoot += '/';

  function route(path) {
    return routeRoot + String(path || '').replace(/^\//, '');
  }

  function request(path, options) {
    var controller = new AbortController();
    var write = options && options.method === 'POST';
    var timer;
    var timeout = new Promise(function (_, reject) {
      timer = setTimeout(function () {
        controller.abort();
        reject(new Error(tvT('Die Verbindung hat zu lange gedauert.')));
      }, 20000);
    });
    var transport = fetch(route(path), Object.assign({}, options, { signal: controller.signal })).then(function (response) {
      if (!response.ok) {
        return response.json().catch(function () { return {}; }).then(function (body) {
          var message = body.description || body.message || tvT('Die Auswahl konnte nicht gespeichert werden.');
          var error = new Error(message);
          error.tvRejected = response.status >= 400 && response.status < 500;
          throw error;
        });
      }
      return response.json();
    });
    return Promise.race([transport, timeout]).catch(function (error) {
      // An aborted/lost POST may already have reached Shopify. Never retry it
      // or claim a rollback merely because the browser did not get a response.
      error.tvUncertain = Boolean(write && !error.tvRejected);
      throw error;
    }).finally(function () { clearTimeout(timer); });
  }

  function getCart() {
    return request('cart.js', { headers: { Accept: 'application/json' } });
  }

  function variantLines(cart, variantId) {
    var id = String(variantId);
    return (cart.items || []).filter(function (item) { return String(item.variant_id) === id; });
  }

  function setOptionState(option, inCart) {
    var input = option.querySelector('[data-tv-extra-input]');
    var state = option.querySelector('[data-tv-extra-state]');
    if (!input) return;
    option.dataset.inCart = inCart ? 'true' : 'false';
    if (inCart) input.checked = true;
    if (state) state.textContent = inCart ? tvT('Im Warenkorb') : (input.checked ? tvT('Wird mitbestellt') : '');
  }

  function setBusy(root, busy) {
    root.setAttribute('aria-busy', busy ? 'true' : 'false');
    root.querySelectorAll('[data-tv-extra-input]').forEach(function (input) { input.disabled = busy; });
  }

  function removeVariant(cart, variantId) {
    var lines = variantLines(cart, variantId);
    return lines.reduce(function (promise, line) {
      return promise.then(function () {
        return request('cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: 0 })
        });
      });
    }, Promise.resolve(cart));
  }

  function changeLine(key, quantity) {
    return request('cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    });
  }

  function signature(cart) {
    return JSON.stringify((cart.items || []).map(function (line) {
      return [String(line.key), Number(line.quantity)];
    }).sort(function (a, b) { return a[0].localeCompare(b[0]); }));
  }

  function rollback(before, added, variantIds, quantity) {
    if (!before || !added || !added.key) return Promise.reject(new Error(tvT('Der Warenkorbstatus ist unklar.')));
    return getCart().then(function (current) {
      if (signature(current) === signature(before)) return current;
      var previous = (before.items || []).find(function (line) { return line.key === added.key; });
      var previousQuantity = previous ? previous.quantity : 0;
      var main = (current.items || []).find(function (line) { return line.key === added.key; });
      if (!main || main.quantity !== previousQuantity + quantity) throw new Error(tvT('Der Warenkorb wurde zwischenzeitlich verändert.'));
      var extras = (current.items || []).filter(function (line) {
        return variantIds.some(function (id) { return String(id) === String(line.variant_id); }) && variantLines(before, line.variant_id).length === 0;
      });
      if (extras.some(function (line) { return line.quantity !== 1; })) throw new Error(tvT('Die Extra-Menge hat sich verändert.'));
      var proposed = { items: (current.items || []).filter(function (line) {
        return line.key !== added.key && !extras.some(function (extra) { return extra.key === line.key; });
      }).concat(previous ? [previous] : []) };
      if (signature(proposed) !== signature(before)) throw new Error(tvT('Der Warenkorb wurde zwischenzeitlich verändert.'));
      // Only this attempt's exact, expected delta may be undone. Never delete
      // arbitrary pre-existing items or silently accept a failed rollback.
      return extras.reduce(function (promise, line) {
        return promise.then(function () { return changeLine(line.key, 0); });
      }, Promise.resolve()).then(function () {
        return changeLine(added.key, previousQuantity);
      }).then(getCart).then(function (verified) {
        if (signature(verified) !== signature(before)) throw new Error(tvT('Die Rücksetzung konnte nicht bestätigt werden.'));
        return verified;
      });
    });
  }

  function init(root) {
    if (!root) return;
    var form = document.getElementById(root.dataset.productFormId || '');
    var options = Array.from(root.querySelectorAll('[data-tv-extra]'));
    var status = root.querySelector('[data-tv-extras-status]');
    if (!form || !options.length) return;
    if (root.__tvExtrasForm === form) return;
    if (root.__tvExtrasAbort) root.__tvExtrasAbort.abort();
    var lifecycle = new AbortController();
    root.__tvExtrasAbort = lifecycle;
    root.__tvExtrasForm = form;

    root.dataset.tvExtrasReady = 'true';
    root.hidden = false;
    var storageKey = 'tilvy:extras:pending:' + form.getAttribute('id');
    var reviewRequired = false;
    var mutationStarted = false;
    var buttonStates = [];

    function markAttempt(pending) {
      try {
        if (pending) sessionStorage.setItem(storageKey, '1');
        else sessionStorage.removeItem(storageKey);
      } catch (error) { /* In-page locking remains available. */ }
    }

    function working(busy) {
      setBusy(root, busy);
      if (busy && !buttonStates.length) {
        buttonStates = Array.from(document.querySelectorAll('[form="' + form.getAttribute('id') + '"][type="submit"]')).map(function (button) {
          var state = { button: button, disabled: button.disabled };
          button.disabled = true;
          return state;
        });
      } else if (!busy) {
        buttonStates.forEach(function (state) {
          state.button.disabled = state.disabled || state.button.dataset.tvMissingForm === 'true' || state.button.getAttribute('aria-disabled') === 'true';
        });
        buttonStates = [];
      }
    }

    function requireCartReview() {
      reviewRequired = true;
      markAttempt(true);
      working(true);
      root.setAttribute('aria-busy', 'false');
      writeStatus(tvT('Die letzte Änderung ist nicht sicher bestätigt. Bitte prüfe zuerst deinen Warenkorb, bevor du erneut hinzufügst.'));
      if (status) {
        var link = document.createElement('a');
        link.href = route('cart');
        link.textContent = tvT(' Warenkorb prüfen');
        status.appendChild(link);
      }
    }

    function confirmed(cart) {
      options.forEach(function (option) {
        setOptionState(option, variantLines(cart, option.dataset.variantId).length > 0);
      });
    }

    function writeStatus(message) {
      if (status) status.textContent = message || '';
    }

    function sync() {
      return getCart().then(function (cart) {
        if (!reviewRequired && root.getAttribute('aria-busy') !== 'true') confirmed(cart);
        return cart;
      }).catch(function () {
        /* The options remain usable when the read-only sync request is blocked.
           Exact writes still surface their own error and never fake success. */
      });
    }

    options.forEach(function (option) {
      var input = option.querySelector('[data-tv-extra-input]');
      if (!input) return;
      input.addEventListener('change', function () {
        if (reviewRequired || root.getAttribute('aria-busy') === 'true') return;
        writeStatus('');
        if (input.checked) {
          setOptionState(option, option.dataset.inCart === 'true');
          return;
        }
        if (option.dataset.inCart !== 'true') {
          setOptionState(option, false);
          return;
        }

        working(true);
        mutationStarted = false;
        writeStatus(tvT('Auswahl wird entfernt …'));
        getCart()
          .then(function (cart) {
            mutationStarted = true;
            markAttempt(true);
            return removeVariant(cart, option.dataset.variantId);
          }).then(getCart)
          .then(function (cart) {
            if (variantLines(cart, option.dataset.variantId).length) throw new Error(tvT('Die Entfernung ist nicht bestätigt.'));
            setOptionState(option, false);
            markAttempt(false);
            working(false);
            writeStatus(tvT('Auswahl entfernt.'));
          })
          .catch(function (error) {
            if (mutationStarted) { requireCartReview(); return; }
            input.checked = true;
            setOptionState(option, true);
            working(false);
            writeStatus(tvT('Keine Änderung vorgenommen. Bitte versuche es erneut.'));
          });
      }, { signal: lifecycle.signal });
    });

    form.addEventListener('submit', function (event) {
      if (!root.isConnected || document.getElementById(root.dataset.productFormId || '') !== form) return;
      if (reviewRequired || root.getAttribute('aria-busy') === 'true') { event.preventDefault(); return; }
      if (event.defaultPrevented) return;
      var pending = options.filter(function (option) {
        var input = option.querySelector('[data-tv-extra-input]');
        return input && input.checked && option.dataset.inCart !== 'true';
      });
      if (!pending.length) return;

      event.preventDefault();
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      // Capture exactly the validated native multipart data before any wait.
      var payload = new FormData(form);
      // Keep the same validated add flow for direct checkout, including paid extras.
      var directCheckout = event.submitter && event.submitter.hasAttribute('data-tv-direct-checkout');
      var quantity = parseInt(payload.get('quantity'), 10) || 1;
      working(true);
      mutationStarted = false;
      writeStatus(tvT('Geschenk und Extras werden hinzugefügt …'));

      var before;
      var addedMain;
      var variantIds;

      getCart()
        .then(function (cart) {
          before = cart;
          variantIds = pending.map(function (option) { return Number(option.dataset.variantId); })
            .filter(function (id) { return id && variantLines(cart, id).length === 0; });
          mutationStarted = true;
          markAttempt(true);
          return request('cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: payload
          });
        })
        .then(function (item) {
          addedMain = item;
          if (!item || !item.key) throw new Error(tvT('Die Produktaufnahme ist nicht bestätigt.'));
          if (!variantIds.length) return null;
          return request('cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: variantIds.map(function (id) { return { id: id, quantity: 1 }; }) })
          });
        })
        .then(getCart)
        .then(function (cart) {
          var oldMain = (before.items || []).find(function (line) { return line.key === addedMain.key; });
          var currentMain = (cart.items || []).find(function (line) { return line.key === addedMain.key; });
          if (!currentMain || currentMain.quantity !== (oldMain ? oldMain.quantity : 0) + quantity || variantIds.some(function (id) { return !variantLines(cart, id).length; })) {
            throw new Error(tvT('Der Warenkorbstatus ist nicht eindeutig bestätigt.'));
          }
          markAttempt(false);
          window.location.assign(route(directCheckout ? 'checkout' : 'cart'));
        })
        .catch(function (error) {
          if (!mutationStarted) {
            markAttempt(false);
            working(false);
            writeStatus('Nicht hinzugefügt. ' + error.message + ' Bitte versuche es erneut.');
            return;
          }
          if (!addedMain && error.tvRejected) {
            // Even an explicit HTTP rejection is not proof that the cart is
            // unchanged (for example inventory adjustments). Read it back.
            getCart().then(function (verified) {
              if (signature(verified) !== signature(before)) { requireCartReview(); return; }
              markAttempt(false);
              confirmed(verified);
              working(false);
              writeStatus(tvT('Nicht hinzugefügt. Dein Warenkorb ist unverändert. Bitte versuche es erneut.'));
            }).catch(requireCartReview);
            return;
          }
          if (error.tvUncertain || !addedMain || !error.tvRejected) { requireCartReview(); return; }
          writeStatus(tvT('Das Extra konnte nicht hinzugefügt werden. Der Warenkorb wird geprüft …'));
          rollback(before, addedMain, variantIds || [], quantity).then(function (verified) {
            markAttempt(false);
            confirmed(verified);
            working(false);
            writeStatus(tvT('Nicht hinzugefügt. Dein vorheriger Warenkorb ist wiederhergestellt. Bitte versuche es erneut.'));
          }).catch(requireCartReview);
        });

      return false;
    }, { signal: lifecycle.signal });

    try { reviewRequired = sessionStorage.getItem(storageKey) === '1'; } catch (error) {}
    if (reviewRequired) requireCartReview();
    else sync();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-tv-one-click-extras]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function () { boot(document); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-tv-one-click-extras]').forEach(function (root) {
      if (root.__tvExtrasAbort) root.__tvExtrasAbort.abort();
      root.__tvExtrasForm = null;
    });
  });
})();
